import React from "react";
import { Link } from "react-router-dom";
import { MEDIA_URL } from "../../config/url";
import { Avatar } from "@mui/material";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import "../../assets/css/review.css";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { encryptData } from "../../utils/storage";
import { removeSpace } from "../../utils";

const Reviews = ({ reviewtable, fetchingDashbboard }) => {
  return (
    <>
      <section className="layout-pt-sm layout-pb-md">
        <div
          // data-anim="slide-up delay-1"
          className="container"
        >
          <div className="row y-gap-10 justify-between items-end">
            <div className="sectionTitle -md">
              <h2 className="sectionTitle__title text-primary text-center">
                Recent Event Reviews
              </h2>
            </div>
          </div>

          <div className="pt-20 sm:pt-20">
            <Swiper
              className="review_button"
              spaceBetween={50}
              slidesPerView={1}
              navigation
              // pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              loopFillGroupWithBlank={true}
              modules={[Navigation, Autoplay]}
              // modules={[Navigation, Pagination, Scrollbar, A11y]}
              // modules={[Navigation, Pagination]}
            >
              <div>
                {fetchingDashbboard ? (
                  <SwiperSlide>
                    {" "}
                    <div className="skeleton-loader"></div>{" "}
                  </SwiperSlide>
                ) : (
                  reviewtable?.map((rowdatabreview) => {
                    const encryptedParam = encryptData(
                      rowdatabreview?.Event_Id
                    );
                    return (
                      <SwiperSlide
                        // id=""
                        key={rowdatabreview.Review_Id}
                      >
                        <div
                          key={rowdatabreview.Review_Id}
                          className="swiper-slide lg:pl-35 lg:pr-25 px-70 py-10"
                        >
                          <Link
                            href="#"
                            className="reviewCard -type-1 d-flex x-gap-10 items-center px-20 lg:px-10 py-20 lg:py-10 rounded-22 lg:rounded-8 row"
                          >
                            <div className="reviewCard__content col-lg-6 pr-30 lg:pr-0 lg:pl-0">
                              <h4 className="reviewCard__title text-dark-1 text-18 lg:text-16 lh-16 fw-600">
                                <Link
                                  to={`/event-details/${removeSpace(
                                    rowdatabreview.Event_Name
                                  )}/${encryptedParam}`}
                                >
                                  {rowdatabreview.Event_Name}
                                </Link>
                              </h4>
                              <p className="lh-14 text-12 mt-10 fw-600 text-primary">
                                <i className="fas fa-map-marker-alt text-primary text-16 mr-10"></i>
                                {rowdatabreview?.City}, {rowdatabreview?.State}
                              </p>
                              <div className="d-flex items-center justify-between mt-5 flex-wrap">
                                <div className="d-flex items-center justify-between font-inter">
                                  <div className="text-12 text-light-1 fw-600 m-1 mr-20">
                                    {" "}
                                    {rowdatabreview.Created_On}
                                  </div>
                                  {rowdatabreview.Rating_Avg > 0 ? (
                                    <div className="text-12 fw-600 text-light-1 m-1">
                                      {" "}
                                      <i className="fas fa-star text-green text-12 fw-600 mr-5"></i>
                                      {rowdatabreview.Rating_Avg}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                {/* <div className="fr"> */}
                                <Link to={`/event-reviews/${encryptedParam}`}>
                                  <div className="font-inter rounded-25 flex-center border-primary px-20 py-10 m-1 button -primary-1 text-primary">
                                    <span className="text-12 fw-500 lh-12">
                                      View all reviews
                                    </span>
                                  </div>
                                </Link>
                                {/* </div> */}
                              </div>
                              <div className="mt-15 border-primary rounded-8 py-10 lg:py-10 px-10">
                                <div className="d-flex x-gap-20">
                                  <Avatar
                                    sx={{
                                      bgcolor: "#EE5636",
                                      marginLeft: "15px",
                                      marginRight: "15px",
                                      width: "55px",
                                      height: "55px",
                                    }}
                                    // variant="square"
                                  >
                                    {rowdatabreview?.Created_By_Name?.slice(
                                      0,
                                      1
                                    )}
                                  </Avatar>
                                  <div className="cardcontent">
                                    <h4 className="text-12 text-dark-1 mb-15">
                                      {rowdatabreview?.Created_By_Name}
                                    </h4>
                                    {rowdatabreview.Rating > 0 ? (
                                      <div className="d-flex mb-15">
                                        {Array.from({ length: 5 }, (_, i) => (
                                          <i
                                            key={i}
                                            className={`fa-star text-11 mr-5 ${
                                              i < rowdatabreview.Rating
                                                ? "fas star-color"
                                                : "far fw-200"
                                            }`}
                                            style={
                                              i >= rowdatabreview.Rating
                                                ? { color: "#949494" }
                                                : {}
                                            }
                                          ></i>
                                        ))}
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                    <p className="lh-14 text-dark-1 fw-600 text-13 mb-10 lg:mb-0 trim-2 font-inter">
                                      {rowdatabreview.Review}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="reviewCard__image col-lg-6 ratio ratio-2:1 lg:mb-10">
                              <img
                                className="rounded-8 col-12 img-ratio"
                                src={`${MEDIA_URL}${rowdatabreview.Image_Path}`}
                                alt="review-img"
                                // style={{ height: "300px" }}
                              />
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                    );
                  })
                )}
              </div>
            </Swiper>
          </div>
          {/* <button className="section-slider-nav -prev flex-center bg-white text-dark-1 size-40 rounded-full shadow-1 sm:d-none  js-prev border-primary">
              <i class="fas fa-arrow-left text-12 text-primary"></i>
            </button>
            <button className="section-slider-nav -next flex-center bg-white text-dark-1 size-40 rounded-full shadow-1 sm:d-none  js-next border-primary">
              <i class="fas fa-arrow-right text-12 text-primary"></i>
            </button>
            <div className="d-flex x-gap-15 items-center justify-center sm:justify-start pt-40 sm:pt-20">
              <div className="col-auto">
                <div className="pagination -dots text-border js-hotels-pag"></div>
              </div>
            </div> */}
          {/* </div> */}
        </div>
      </section>
    </>
  );
};

export default Reviews;
